<template>
    <div v-if="rejectShow" class="popup" @click.self="closePopup">

        <div class="popup-content">
            <p class="poup_title">{{ title }}</p>
            <p class="himt">{{ himt }}</p>
            <div class="popup_box flex" v-if="id == 2">
                <p class="popup_p">
                    选择原因:
                </p>
                <el-select v-model="reason_id" class="poup_input">
                    <el-option v-for="item in classArray" :label="item.label" :key="item.value" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="popup_box flex">
                <p class="popup_p">
                    描述:
                </p>
                <el-input class="poup_input" type="input" :placeholder="placeholder" v-model="reason">
                </el-input>
            </div>
            <div class="flex" style="justify-content: flex-end;">
                <button class="up_box" @click.stop="closePopup">取消</button>
                <button class="close_box" @click="confirm">继续</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rejectShow: Boolean,
        rejectItem: Object,
        himt: String,
        order_status: {
            type: [Number, String],
            default: ''
        },
        /*
        为做区分:
        广告主只能填写描述原因, 媒介主可以选择原因并填写原因
         id-为1则是广告主
         id-为2则是媒介主
        */
        id: Number,
        title: String,
        placeholder: String,
    },
    mounted() {
    },
    data() {
        return {
            reason: '',
            reason_id: 0,
            classArray: [
                {
                    value: 0,
                    label: '请选择原因'
                },
                {
                    value: 1,
                    label: '内容不适合'
                },
                {
                    value: 2,
                    label: '无有效来源'
                },
                {
                    value: 3,
                    label: '需要白名单来源'
                },
                {
                    value: 4,
                    label: '已截稿'
                },
                {
                    value: 5,
                    label: '暂停收稿'
                },
                {
                    value: 6,
                    label: '重复提交'
                },
                {
                    value: 7,
                    label: '网站故障'
                },
                {
                    value: 8,
                    label: '标题不行'
                },
                {
                    value: 9,
                    label: '没有收录'
                },
                {
                    value: 10,
                    label: '审核没通过'
                },
                {
                    value: 11,
                    label: '客户申请退款'
                },
                {
                    value: 12,
                    label: '图片不显示'
                },
                {
                    value: 13,
                    label: '这个内容不包收录'
                },
                {
                    value: 14,
                    label: '不能在规定时间内出稿'
                },
            ]
        }
    },
    methods: {
        closePopup() {
            this.reason = ''
            this.reason_id = 0
            this.$emit('rejectClose')
        },
        confirm() {
            if (this.reason_id == 0 && this.$props.id == 2) {
                return this.$message({
                    type: 'warning',
                    message: '请选择原因'
                });
            }
            if (this.reason == '' && this.$props.id == 1) {
                return this.$message({
                    type: 'warning',
                    message: '请填写描述原因'
                });
            }
            let data = {}
            data.id = this.$props.rejectItem.id
            data.status = this.$props.order_status
            data.url = this.$props.rejectItem.order_url
            data.type = this.$props.rejectItem.order_status == 0 && this.$props.order_status == 5 ? 'touid' : ''
            if (this.$props.id == 2) {
                data.reason_id = this.reason_id
                data.reason = this.reason

            } else {
                data.reason = this.reason
            }
            console.log(data);
            this.curlPost('/api/users/order/edit', data).then(res => {
                if (res.data.code) {
                    this.$emit('rejectComfirm')
                    this.reason = ''
                    this.reason_id = 0
                    this.$message({
                        type: 'success',
                        message: '成功'
                    });
                    // if (this.rejectItem.order_status == 5 || this.rejectItem.order_status == 6) {
                    //     this.$message({
                    //         type: 'success',
                    //         message: '申请撤稿成功'
                    //     });
                    // }

                } else {
                   return this.$message({
                        type: 'warning',
                        message:res.data.msg
                    });
                }
            })
        }
    },
}
</script>

<style scoped lang="scss">
.poup_title {
    color: #777;
    padding: 1rem 0 2rem 0;
    box-sizing: border-box;
    font-size: 1rem;
}

.himt {
    font-size: 1.22rem;
    color: #333;
    font-weight: bold;
    text-align: center;
    padding-bottom: 1rem;
}

.popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background: #fff;
    width: 30%;
    /* height: 6rem; */
    padding: 0 1rem 1rem 1rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    text-align: left;

    .popup_box {
        padding-bottom: 1rem;
        box-sizing: border-box;

        .popup_p {
            color: #777;
            font-size: 1.22rem;
            padding: 1rem;
            width: 16%;
            box-sizing: border-box;
            text-align: right;
        }

        ::v-deep .el-textarea__inner {
            padding-top: 0.8rem;
            box-sizing: border-box;
            font-size: 1.22rem;
        }
    }


    .close_box {
        padding: 0.8rem 2rem;
        box-sizing: border-box;
        background: #2A82E4;
        color: #fff;
        border-radius: 0.2rem;
        border: 0;
        cursor: pointer;
    }

    .up_box {
        padding: 0.8rem 2rem;
        box-sizing: border-box;
        background: #fff;
        color: #2A82E4;
        border: 0.1rem solid #aaa;
        border-radius: 0.2rem;
        cursor: pointer;
        margin-right: 1rem;
    }
}

.close-button {
    margin-top: 10px;
}

.poup_input {
    width: 70%;
}
</style>